import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './domain.reducer';
import { IDomain } from 'app/shared/model/domain.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IDomainDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export class DomainDetail extends React.Component<IDomainDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { domainEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="dealorGatewayApp.domain.detail.title">Domain</Translate> [<b>{domainEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="name">
                <Translate contentKey="dealorGatewayApp.domain.name">Name</Translate>
              </span>
            </dt>
            <dd>{domainEntity.name}</dd>
            <dt>
              <span id="description">
                <Translate contentKey="dealorGatewayApp.domain.description">Description</Translate>
              </span>
            </dt>
            <dd>{domainEntity.description}</dd>
            <dt>
              <span id="createdBy">
                <Translate contentKey="dealorGatewayApp.domain.createdBy">Created By</Translate>
              </span>
            </dt>
            <dd>{domainEntity.createdBy}</dd>
            <dt>
              <span id="createdDate">
                <Translate contentKey="dealorGatewayApp.domain.createdDate">Created Date</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={domainEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="lastModifiedBy">
                <Translate contentKey="dealorGatewayApp.domain.lastModifiedBy">Last Modified By</Translate>
              </span>
            </dt>
            <dd>{domainEntity.lastModifiedBy}</dd>
            <dt>
              <span id="lastModifiedDate">
                <Translate contentKey="dealorGatewayApp.domain.lastModifiedDate">Last Modified Date</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={domainEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <Translate contentKey="dealorGatewayApp.domain.tenant">Tenant</Translate>
            </dt>
            <dd>{domainEntity.tenant ? domainEntity.tenant.id : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/domain" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
          &nbsp;
          <Button tag={Link} to={`/entity/domain/${domainEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ domain }: IRootState) => ({
  domainEntity: domain.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DomainDetail);
